import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

// TODO: merge `d` attribute into one for 16px
const draw24px =
  'M20.53,5.59,17.34,8.78a.71.71,0,0,1-.53.22.79.79,0,0,1-.29-.06.74.74,0,0,1-.46-.69V5.81H4a.75.75,0,1,1,0-1.5H16.06V1.87a.74.74,0,0,1,.46-.69.73.73,0,0,1,.82.16l3.19,3.19A.74.74,0,0,1,20.53,5.59Zm-9.1,7.89V11.71L1.9,14.77V17.1L11.43,20V18.29l-2.5-.72v-3.3ZM3.1,15.94l4.45-1.26v2.5Zm12.26-.42a2.49,2.49,0,0,0,.75,1.88h-3.4v1.69h9.34V17.77l-.61-.15a2.51,2.51,0,0,0,.79-1.89,2.72,2.72,0,0,0-.44-1.5,3.09,3.09,0,0,0-1.24-1.1,3.7,3.7,0,0,0-1.65-.36h-.11a4.4,4.4,0,0,0-1.81.34,2.76,2.76,0,0,0-1.2,1A2.52,2.52,0,0,0,15.36,15.52Zm3.48-1.06a2.55,2.55,0,0,1,1.57.42A1.32,1.32,0,0,1,21,16a1.84,1.84,0,0,1-.6,1.39H17.41a1.94,1.94,0,0,1-.57-.67,1.8,1.8,0,0,1-.2-.87c0-.93.7-1.4,2.09-1.4Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationHorizontalStackedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(
  generateRenderedIcon(icons, 'textOrientationHorizontalStacked'),
) as IconWithRender;

TextOrientationHorizontalStackedIcon.displayName =
  'TextOrientationHorizontalStackedIcon';
TextOrientationHorizontalStackedIcon.propTypes = Icon.propTypes;
TextOrientationHorizontalStackedIcon.renderIcon = (props) => (
  <TextOrientationHorizontalStackedIcon {...props} />
);
export default TextOrientationHorizontalStackedIcon;
